// extracted by mini-css-extract-plugin
export var disabled = "_s-a";
export var hierarchyLinkGray = "_s-4";
export var hierarchyLinkUnderline = "_s-3";
export var hierarchyPrimary = "_s-0";
export var hierarchySecondary = "_s-1";
export var hierarchyTertiary = "_s-2";
export var pressed = "_s-6";
export var themeAction = "_s-5";
export var themeDestructive = "_s-8";
export var themeNormal = "_s-7";
export var themeSuccess = "_s-9";